//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../Features/Features.FeatureBuilder.js";
import "../Join/Join.OverlapFaceSetsBuilderList.js";
import "../Join/Join.OverlapGuideBuilderList.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"ConnectPart",1,0],[0,"DistanceTolerance",1,0],[1,"FaceSetsList",0,"Join.OverlapFaceSetsBuilderList",0],[0,"GuideCurveCreationType",1,0],[1,"GuideCurvesList",0,"Join.OverlapGuideBuilderList",0],[0,"MaximumBendRadius",1,0],[0,"MaximumCenterlineWidth",1,0],[0,"MaximumGapBetweenBodies",1,0],[0,"MinimumFlangeWidth",1,0],[0,"MoveReferenceSheetToConstructionLayer",1,0],[0,"OffsetFromEdgeDistance",1,0],[1,"OtherBodies",0,"SelectBodyList",0],[0,"ReferenceSheetOption",1,0],[0,"ReferenceSheetType",1,0],[1,"TopBodies",0,"SelectBodyList",0],[0,"Type",1,0]],[[[],"NewFaceSets",{R_:{newfaceSetsBuilder:"Join.OverlapFaceSetsBuilder"}},0,0],[[],"NewGuide",{R_:{newGuideBuilder:"Join.OverlapGuideBuilder"}},0,0],[["facesModified"],"UpdateReferenceSheet",{R_:{sheet:"Features.Feature"}},1,0],[[],"MoveReferenceSheet",{},0,0]],[]];
SPLM.Join.OverlapBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.OverlapBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.OverlapBuilder.InputDataTypes = Object.freeze({
    "Faces" : "Faces", "Bodies" : "Bodies"});

SPLM.Join.OverlapBuilder.ReferenceSheetTypes = Object.freeze({
    "Overlap" : "Overlap", "Top" : "Top"});

SPLM.Join.OverlapBuilder.ConnectPartTypes = Object.freeze({
    "AllUniqueParts" : "AllUniqueParts", "OnlyOnePart" : "OnlyOnePart", "RepeatedParts" : "RepeatedParts"});

SPLM.Join.OverlapBuilder.ReferenceSheetOptionTypes = Object.freeze({
    "TopTarget" : "TopTarget", "BetweenBodies" : "BetweenBodies"});

SPLM.Join.OverlapBuilder.GuideCurveCreationTypes = Object.freeze({
    "Manual" : "Manual", "Automatic" : "Automatic"});

export default SPLM;